import "./SeaAnimals.scss"
import { useContext } from "react"
import { UserContext } from "../../../store/store"
import { useState } from "react"
import { Panel } from "./Panel"
import { useTranslation, Trans } from "react-i18next"

export const SeaAnimals = ({
  me,
  op,
  turno,
  confirmationCell,
  coords,
  myShips,
  opShips,
  animations,
  winCallback,
  onClickMe,
  onClickOp,
  bombMe,
  bombOp,
  debugMode = false,
}) => {
  const [myRatio, setMyRatio] = useState(1)
  const [ratioOp, setRatioOp] = useState(1)

  const { t } = useTranslation()

  const [state] = useContext(UserContext)

  return (
    <>
      <div className="row pt-3 pb-5">
        <div className="d-flex flex-row justify-content-center mt-3 mb-1">
          <div
            className={"sound-alert " + state.theme}
            style={{ width: "fit-content" }}
          >
            🔊 {t(`ui.games.msgs.volume_up`)}
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center mt-1 mb-3">
          <div
            className={"sound-alert " + state.theme}
            style={{ width: "fit-content" }}
          >
            🧙‍♂️ &nbsp;
            <Trans
              i18nKey={
                turno === me.id
                  ? "games.sea_animals.your_turn"
                  : "games.sea_animals.op_turn"
              }
              values={{ op: op ? op.nick : t(`games.sea_animals.your_op`) }}
              components={{ strong: <strong />, u: <u /> }}
            />
          </div>
        </div>
      </div>

      <div className="row gx-5">
        <div className="col-lg-6 col-12 pr-8">
          <Panel
            tilte={me ? me.nick : t(`games.sea_animals.your_fishes`)}
            turno={turno === me.id}
            animations={animations}
            coords={coords}
            ships={myShips}
            ratio={myRatio}
            setRatio={setMyRatio}
            winCallback={winCallback}
            triggerBomb={bombMe}
            onClick={onClickMe}
            reversed
          />
        </div>

        <div className="col-lg-6 col-12">
          <Panel
            tilte={op ? op.nick : t(`games.sea_animals.op_fishes`)}
            turno={turno !== me.id}
            confirmationCell={confirmationCell}
            coords={coords}
            ratio={ratioOp}
            setRatio={setRatioOp}
            ships={opShips}
            winCallback={winCallback}
            isOpponent
            animations={animations}
            triggerBomb={bombOp}
            onClick={onClickOp}
          />
        </div>
      </div>
    </>
  )
}
